import { render, staticRenderFns } from "./Jx3DatRank.vue?vue&type=template&id=372e3474"
import script from "./Jx3DatRank.vue?vue&type=script&lang=js"
export * from "./Jx3DatRank.vue?vue&type=script&lang=js"
import style0 from "./Jx3DatRank.vue?vue&type=style&index=0&id=372e3474&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports